// Template Generated by DataExtraction.py at 1714177343
        
import EnrolmentFormsEn4 from "../../Forms/Enrolment Forms/EnrolmentForms_En4.png";
import EnrolmentFormsEn4Labels from "../../Labels/Enrolment Forms/EnrolmentForms_En4.json";
import EnrolmentFormsFr4 from "../../Forms/Enrolment Forms/EnrolmentForms_Fr4.png";
import EnrolmentFormsFr4Labels from "../../Labels/Enrolment Forms/EnrolmentForms_Fr4.json";
import {
    defaultFontSize,
    drawTextOnLabel,
    fillCheckboxAtLabel,
    standardFormAlias,
    standardFormCompression,
    isLanguageEnglish,
    standardFormFormat,
    standardFormHeight,
    standardFormWidth,
    standardFormX,
    standardFormY
} from "../../PDFGenerationUtils";
import moment from "moment/moment";

/*
 * @param doc {jsPDF}
 */
const generate = (doc, data, quote, authStatus, i18n) => {

    const isFrench = !isLanguageEnglish(i18n);
    const labels = isFrench ? EnrolmentFormsFr4Labels : EnrolmentFormsEn4Labels;
    const formImage = isFrench ? EnrolmentFormsFr4 : EnrolmentFormsEn4;

    function fillCheckbox(value, label){
        fillCheckboxAtLabel(doc, value, label, labels);
    }
    
    function drawText(value, label){
        drawTextOnLabel(doc, value, label, labels);
    }

    // add image
    doc.addImage(formImage, standardFormFormat, labels["image"]["x"], labels["image"]["y"], labels["image"]["width"], labels["image"]["height"], null, standardFormCompression);

    /* define state variables here ie:
     * const subscriber = data.subscriber;
     * const jointSubscriber = data.jointSubscriber;
     * const beneficiary = data.beneficiary;
    */

    // Drawing the form

}

//Returns the signature definitions for the document
// This includes who needs to sign and where
const signatureDefinitions = (state, documentId, pageNumber, i18n) => {
    return null;
}

export default {
    generate,
    signatureDefinitions
}
    